//--------------------------------------------------
// imported classes
//--------------------------------------------------
const Invitation = require('./Invitation')
const ClassFunc = require('../../util/ClassFunc')

/**
 * The Player class works as the player translator.
 */
const tbs_model_to_Executor = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Invitation, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_to_Executor.prototype = {
    'match-executor': '赛事执行',
}

//--------------------------------------------------
// extends the Invitation
//--------------------------------------------------
ClassFunc.extend(tbs_model_to_Executor, Invitation);

module.exports = tbs_model_to_Executor